module.exports = __webpack_public_path__ + "media/images/classifieds_2-a3138d9b217937fed958d6233cdb3542.png";